import * as _ from "lodash";
import { createSlice } from "@reduxjs/toolkit";
import { AnyIfEmpty } from "react-redux";

export interface IFonctionnaliteState {
  fonctionnalites: IFonctionnalite[];
  fonctionnalitesByGroupeFonctionalite: IFonctionnalite[];
  objFonctionnalite: IFonctionnalite;
  openDialogFonctionnalite: boolean,
  valueEdit:string;
  descriptionEdit:string;
  filterfonctionnalites:IFonctionnalite[];
}

export interface IFonctionnalite {
  idModule: string;
  idSousModule: string;
  idGroupeFonctionnalite: string;
  idFonctionnalite: string;
  libelleFonctionnalite: string;
  descriptionFonctionnalite:string;
}



export const fonctionnaliteSlice: any = createSlice({
  name: "fonctionnalite",
  initialState: {
    openDialogFonctionnalite: false,
    fonctionnalites: [],
    objFonctionnalite: {},
    fonctionnalitesByGroupeFonctionalite: [],
    valueEdit:"",
    descriptionEdit:"",
    filterfonctionnalites:[]
  },
  reducers: {

    addFonctionnalites: (state, action) => {
      const newFonctionnalite: any = [...state.fonctionnalites, action.payload]
      state.fonctionnalites = newFonctionnalite;
    },

    setValueEdit: (state, action) => {
      state.valueEdit = action.payload;
    },
    setDescriptionEdit: (state, action) => {
      state.descriptionEdit = action.payload;
    },

    setFonctionnalites: (state, action) => {
      state.fonctionnalites = action.payload;
    },

    setFilterFonctionnalites: (state, action) => {
      state.filterfonctionnalites = action.payload;
    },

    setObjFonctionnalite: (state, action) => {
      state.objFonctionnalite = action.payload;
    },

    setFonctionalitesByGroupeFonctionalite: (state, action) => {
      state.fonctionnalitesByGroupeFonctionalite = action.payload;
    },


    setOpenDialogFonctionnalite: (state, action) => {
      state.openDialogFonctionnalite = action.payload;
    },

    deleteFonctionnalite: (state, action) => {
      state.fonctionnalites = state.fonctionnalites.filter((f: IFonctionnalite) => f.idFonctionnalite !== action.payload);
    },

    editFonctionnalite: (state, action) => {
      const newF: any = state.fonctionnalites.map((f: IFonctionnalite) => (f.idFonctionnalite === action.payload.idFonctionnalite ? action.payload : f))
      state.fonctionnalites = newF;
    },


  }
});

export const {
  setOpenDialogFonctionnalite,
  addFonctionnalites,
  setFonctionnalites,
  setObjFonctionnalite,
  setFonctionalitesByGroupeFonctionalite,
  deleteFonctionnalite,
  editFonctionnalite,
  setValueEdit,
  setDescriptionEdit,
  setFilterFonctionnalites
} = fonctionnaliteSlice.actions;


export default fonctionnaliteSlice.reducer;
